import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { IoHomeOutline, IoHomeSharp } from "react-icons/io5";
import { IoStorefrontOutline, IoStorefrontSharp } from "react-icons/io5";
import { VscDashboard } from "react-icons/vsc";
import { RiAccountCircleLine } from "react-icons/ri";
import { RiKeyboardBoxLine, RiKeyboardBoxFill } from "react-icons/ri";
import { googleLogout, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import Photosicon from '../assets/photos_icon.png';
import "./Navbar.css";
import { MdAdd, MdApps, MdCall } from 'react-icons/md';
import { GiSecurityGate } from "react-icons/gi";
export default function Navbar() {
  const location = useLocation(); // Get current route
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingUser != null && existingsessiontoken !=null ) {
      setGuid(existingUser);
      setuserlogin(true);
      const photo = Cookies.get("photoURL"); 
      setPhotoURL(photo);
    } else {
      setuserlogin(false);
    }
  }, []);
  // const handleGoogleLogin = async () => {
  //   const userData = await signInWithGoogle();
  //   setUser(userData);
  //   setTimeout(() => window.location.reload(), 2000);
  // };


  return (
    <nav className="navbar">
      <div
        onClick={() => navigate('/')}
        className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
        title="Home"
      >
        {location.pathname === '/' ? <IoHomeSharp className="icon" /> : <IoHomeOutline className="icon" />}
        <span className="button-text">Home</span>
      </div>

      <div
        onClick={() => navigate('/post-status')}
        className={`menubutton-icon ${location.pathname === '/post-status' ? 'active' : ''}`}
        title="Post Status"
      >
        {location.pathname === '/post-status' ? <MdAdd className="icon" /> : <MdAdd className="icon" />}
        <span className="button-text">Post Status</span>
      </div>

    

      <div

      
        className={`menubutton-icon ${location.pathname === '/account' ? 'active' : ''}`}
        title="dashboard"
      >
        {userlogin == true && (
          <img onClick={() => navigate('/account')}
            src={photoURL || Photosicon}
            onError={(e) => { e.currentTarget.src = Photosicon; }}
            className="img-icon rounded-circle shadow hover"
          />

        )}
        {userlogin == false && (
            <div className='login_button' onClick={() => navigate('/login')}>
            <RiAccountCircleLine className="icon" />
          </div>
       
        )}
      </div>
    </nav>
  );
};